import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../hooks/useAuth';
import LanguageSelector from '../components/LanguageSelector';
import './Auth.css';

const Login = () => {
  const { t } = useTranslation();
  const { login } = useAuth();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    username_or_email: '',
    password: '',
  });
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await login(formData);
      navigate('/');
    } catch (err) {
      setError(err.error || t('auth.invalidCredentials'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-split fade-in">
        {/* Left side - Branding */}
        <div className="auth-brand">
          <div className="brand-curves"></div>
          <div className="brand-content">
            <div className="brand-logo">
              <img src="/header-icon.png" alt="emoozi" />
              <span className="brand-logo-text">emoozi</span>
            </div>
            <h1 className="brand-headline">
              Your people. Your space.
            </h1>
            <p className="brand-subheadline">
              {t('auth.brandSubheadline')}
            </p>
          </div>
        </div>

        {/* Right side - Form */}
        <div className="auth-form-side">
          <div className="auth-card">
            <div className="auth-card-header">
              <h2>{t('auth.welcomeBack')}</h2>
              <p className="auth-card-subtitle">{t('auth.enterDetails')}</p>
            </div>

            {error && (
              <div className="error-message">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit} className="auth-form">
              <div className="form-group">
                <label>{t('auth.usernameOrEmail')}</label>
                <input
                  type="text"
                  name="username_or_email"
                  value={formData.username_or_email}
                  onChange={handleChange}
                  placeholder={t('auth.enterUsernameOrEmail')}
                  required
                />
              </div>

              <div className="form-group">
                <label>{t('auth.password')}</label>
                <input
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder={t('auth.enterPassword')}
                  required
                />
              </div>

              <div className="form-options">
                <label className="remember-me">
                  <input
                    type="checkbox"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                  />
                  {t('auth.rememberMe')}
                </label>
                <Link to="/forgot-password" className="forgot-password">
                  {t('auth.forgotPassword')}
                </Link>
              </div>

              <button type="submit" className="primary" disabled={loading}>
                {loading ? <span className="loading-spinner-small"></span> : t('auth.continue')}
              </button>
            </form>

            <p className="trust-signal">
              {t('auth.privateByDefault')}
            </p>

            <p className="auth-footer">
              {t('auth.dontHaveAccount')}{' '}
              <Link to="/register">{t('auth.createOne')}</Link>
            </p>

            <LanguageSelector />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
